import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CryptoService } from '../services/crypto.service';
import { map } from 'rxjs/operators';
import { CryptRequest, CryptResponse } from '../models/crypt-request.model';
import { toCamel, toSnake } from '@/app/utils/string-utils';

function snakeKeyString(k: string) {
  return k.replace(/([A-Z])/g, '_$1').replace(/[\s\-]+/g, '_').toLowerCase();
}

export const cryptoInterceptor: HttpInterceptorFn = (req, next) => {
  const cryptoService = inject(CryptoService);

  let newReq = req;
  const isFormData = req.body instanceof FormData;
  
  if (req.body) {
    if(isFormData){
      const form = new FormData();
      (req.body as FormData).forEach((value, key) => {
        const snakeKey = snakeKeyString(key);
        form.append(snakeKey, value);
      });
      newReq = req.clone({ body: form });
    }else{
      try {
        const snakeBody = toSnake(req.body);
        const jsonString = JSON.stringify(snakeBody);
        const encted = cryptoService.zW5jcnlwdA(jsonString);
        const cryptRequest: CryptRequest = { dmFsdWU: encted };
        newReq = req.clone({ body: cryptRequest });
      } catch (error) {
        const jsonString = JSON.stringify(req.body);
        const encted = cryptoService.zW5jcnlwdA(jsonString);
        const cryptRequest: CryptRequest = { dmFsdWU: encted };
        newReq = req.clone({ body: cryptRequest });
      }
    }
  }

  return next(newReq).pipe(
    map((event: any) => {
      if (event instanceof HttpResponse && event.body?.cmVzcG9uc2U) {
        const encResponse = event.body.cmVzcG9uc2U;
        const decJson = cryptoService.zGVjcnlwdA(encResponse);
        try {
          const camelBody = toCamel(JSON.parse(decJson)) ;
          event = event.clone({ body: camelBody });
        } catch {
          event = event.clone({ body: decJson });
        }
      }
      return event;
    })
  );
};
